// ---------------------------------------------------------------------------
// Shortcuts API client — Round 9 (2026).
// Replaces the per-browser localStorage "sswHome:shortcuts" key with
// per-user, server-side storage so shortcuts follow the user across
// browsers and devices.
// ---------------------------------------------------------------------------
import api from "../api";

/** Returns this user's shortcuts (ordered by SortOrder, then Id). */
export const fetchShortcuts = async () => {
    const res = await api.get("/shortcuts");
    return Array.isArray(res.data) ? res.data : [];
};

/**
 * Pin a catalog entry as a shortcut.
 * @param {Object} entry  From SHORTCUT_CATALOG in Home/index.js.
 * @param {string} entry.key     Stable catalog key, e.g. "epo-create".
 * @param {string} entry.to      Route path, e.g. "/expense-purchase-order".
 * @param {string} entry.label   Display label.
 * @param {string} [entry.icon]  Optional remix icon name.
 */
export const addShortcut = async (entry) => {
    const res = await api.post("/shortcuts", {
        shortcutKey: entry.key,
        path:        entry.to,
        label:       entry.label,
        icon:        entry.icon || null,
    });
    return res.data;
};

/** Remove a shortcut by its server id. */
export const removeShortcut = async (id) => {
    await api.delete(`/shortcuts/${id}`);
};

/**
 * Persist a new drag-order. Pass the list in display order; the helper
 * assigns sequential SortOrder values.
 */
export const reorderShortcuts = async (orderedList) => {
    const items = orderedList.map((s, i) => ({ id: s.id, sortOrder: i }));
    await api.put("/shortcuts/reorder", { items });
};
